import React from 'react';
import {Provider as ReduxProvider} from 'react-redux';
import {BrowserRouter, Routes, Route} from 'react-router-dom';

import {useDarkMode} from './hooks/use-dark-mode';

import {App} from './App';
import {RegisteredClient} from './RegisteredClient';
import {store} from './state/store';
import {NetworkProvider} from './NetworkProvider';
import {SSEProvider} from './SSEProvider';
import {ToastProvider} from './components/ui/toast';
import {Chat, ChatWindow} from './Chat';
import {ReviewWindow} from './Review';
import {Login} from './Login';
import {Setup} from './Setup';
import {OAuth2Callback} from './OAuth2Callback';
import {BrowserId} from './BrowserId';
import {LogoutSplash} from './Logout';
import {Settings} from './Settings';
import {Help} from './Help';

/**
 * The root component supplies all the Providers and Routes to run the app.
 *
 * Try to keep all the core App features (as opposed to the services providers)
 * inside of the Route `element` props. That way it's easier to mock these
 * service dependencies for testing.
 */
export const Root = () => {
  // Initialize dark mode system
  useDarkMode();

  return (
    <BrowserId>
      <ReduxProvider store={store}>
        <ToastProvider>
          <NetworkProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/oauth2/callback" element={<OAuth2Callback />} />
                <Route path="/setup" element={<Setup />} />
                <Route path="/login" element={<Login />} />
                <Route path="/logout" element={<LogoutSplash />} />
                <Route
                  path="/"
                  element={
                    <RegisteredClient>
                      <SSEProvider source="/events/sse">
                        <App />
                      </SSEProvider>
                    </RegisteredClient>
                  }
                >
                  <Route path="" element={<ChatWindow />} />
                  <Route path="chat" element={<ChatWindow />}>
                    <Route path=":accountId">
                      <Route path="" element={<Chat />} />
                    </Route>
                  </Route>
                  <Route path="review" element={<ReviewWindow />}></Route>
                  <Route path="settings" element={<Settings />} />
                  <Route path="help" element={<Help />} />
                </Route>
              </Routes>
            </BrowserRouter>
          </NetworkProvider>
        </ToastProvider>
      </ReduxProvider>
    </BrowserId>
  );
};
